import type { Room } from '@hollowveil/shared';

export const roomForestGarden: Room = {
      id: 'room_forest_garden',
      name: "Le Jardin Enchanté",
      description: "Un ancien jardin envahi par la végétation. Les esprits de la nature y résident encore.",
      size: [22, 10, 22],
      floorStyle: 'grass',
      ambiance: {
        realWorld: {
          backgroundColor: '#e8f5e9',
          ambientLightColor: '#a5d6a7',
          ambientLightIntensity: 0.7,
        },
        spectralWorld: {
          backgroundColor: '#1a2e1a',
          ambientLightColor: '#4a7c59',
          ambientLightIntensity: 0.4,
        },
      },
      objects: [
        // Trees - using low-poly tree model
        {
          id: 'obj_tree_1',
          name: 'Grand Arbre',
          type: 'static',
          modelId: 'tree',
          position: [2, 0, 2],
          rotation: [0, 0.3, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tree_2',
          name: 'Arbre Ancien',
          type: 'static',
          modelId: 'ancient_tree',
          position: [10, 0, 2],
          rotation: [0, 1.5, 0],
          scale: [1.2, 1.4, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tree_3',
          name: 'Petit Arbre',
          type: 'static',
          modelId: 'tree',
          position: [1, 0, 10],
          rotation: [0, 2.1, 0],
          scale: [0.8, 0.9, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Bushes
        {
          id: 'obj_bush_1',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [3, 0, 1],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_bush_2',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [11, 0, 5],
          rotation: [0, 1.2, 0],
          scale: [1.2, 1.1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Rocks and stones
        {
          id: 'obj_stone_1',
          name: 'Pierre Moussue',
          type: 'static',
          modelId: 'rock',
          position: [4, 0, 8],
          rotation: [0, 0.3, 0],
          scale: [1.2, 1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_rocks_path',
          name: 'Cailloux',
          type: 'static',
          modelId: 'rocks',
          position: [8, 0, 9],
          rotation: [0, 0.8, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Flowers
        {
          id: 'obj_flower_1',
          name: 'Fleur Sauvage',
          type: 'static',
          modelId: 'flower',
          position: [5, 0, 2],
          rotation: [0, 0.5, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_flower_2',
          name: 'Fleur Sauvage',
          type: 'static',
          modelId: 'flower',
          position: [9, 0, 4],
          rotation: [0, 1.8, 0],
          scale: [0.9, 0.9, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Plants
        {
          id: 'obj_plant_garden',
          name: 'Plante',
          type: 'static',
          modelId: 'plant',
          position: [7, 0, 1],
          rotation: [0, 0.3, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Pressure Plate - real world mechanic (opens the door)
        {
          id: 'obj_pressure_plate',
          name: 'Plaque de Pression',
          type: 'trigger',
          modelId: 'block',
          position: [8, 0, 7],
          rotation: [0, 0, 0],
          scale: [1.5, 0.1, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: { variant: 'accent' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La plaque s\'enfonce sous tes pieds. Tu entends une porte s\'ouvrir...',
              },
            },
            {
              type: 'openDoor',
              params: {
                doorId: 'obj_secret_door',
              },
            },
          ],
        },
        // Secret door - opens when pressure plate is activated
        {
          id: 'obj_secret_door',
          name: 'Porte Secrète',
          type: 'static',
          modelId: 'animated_door',
          position: [10.5, 0, 10],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Hidden treasure behind the door - trigger type for auto-pickup
        {
          id: 'obj_hidden_treasure',
          name: 'Trésor Caché',
          type: 'trigger',
          modelId: 'crystal',
          position: [10.5, 0.3, 11.5],
          rotation: [0, 0, 0],
          scale: [1, 1.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'hidden_treasure',
                itemName: 'Trésor du Jardin',
                itemDescription: 'Un ancien artefact qui pulse d\'énergie mystique.',
                itemIcon: 'gem',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as trouvé le Trésor du Jardin ! Un ancien artefact qui pulse d\'énergie mystique.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_hidden_treasure',
              },
            },
          ],
        },
        // Magic Flower - spectral world
        {
          id: 'obj_magic_flower',
          name: 'Fleur Magique',
          type: 'interactive',
          modelId: 'magic_flower',
          position: [3, 0, 6],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La fleur s\'illumine à ton toucher, répandant des particules de lumière...',
              },
            },
          ],
        },
        // Ancient Tree Spirit - spectral world (requires ancient seed from level 1 to give blessing)
        {
          id: 'obj_ancient_tree_spirit',
          name: 'Esprit de l\'Arbre Ancien',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [10, 0, 2],
          rotation: [0, Math.PI, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'requireItem',
              params: {
                itemId: 'ancient_seed',
                missingMessage: '"Jeune voyageur... Tu portes la marque du Voile, mais tu n\'as pas ce dont j\'ai besoin. Retrouve la Graine Ancienne dans ta maison... Elle brille dans l\'autre monde."',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: '"Tu as trouvé la Graine Ancienne ! Cette semence porte l\'essence de nos ancêtres..."',
              },
            },
            {
              type: 'giveItem',
              params: {
                itemId: 'ancient_seed',
                npcId: 'obj_ancient_tree_spirit',
                successMessage: '"Je plante cette graine dans le sol sacré de la forêt. En échange, accepte ma bénédiction..."',
              },
            },
            {
              type: 'addToInventory',
              params: {
                itemId: 'forest_blessing',
                itemName: 'Bénédiction de la Forêt',
                itemDescription: 'Une énergie ancienne qui peut ouvrir les portes scellées par la nature.',
                itemIcon: 'flower',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: '"La forêt te reconnaît désormais comme un ami. Cette bénédiction ouvrira les portes que la nature a scellées. Va, et protège le Voile."',
              },
              delay: 2000,
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_ancient_tree_spirit',
              },
            },
          ],
        },
        // Spectral Bridge indicator
        {
          id: 'obj_bridge_marker_1',
          name: 'Pont Spectral',
          type: 'static',
          modelId: 'block',
          position: [6, 0.5, 10],
          rotation: [0, 0, 0],
          scale: [3, 0.1, 1],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { variant: 'highlight' },
        },
        // Mysterious orbs for atmosphere
        {
          id: 'obj_orb_1',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [5, 1.5, 3],
          rotation: [0, 0, 0],
          scale: [0.5, 0.5, 0.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_orb_2',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [7, 2, 7],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // === Additional decorations for enlarged room ===
        // More trees spread across the garden
        {
          id: 'obj_tree_4',
          name: 'Arbre',
          type: 'static',
          modelId: 'tree',
          position: [18, 0, 4],
          rotation: [0, 1.2, 0],
          scale: [1.1, 1.3, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tree_5',
          name: 'Arbre Ancien',
          type: 'static',
          modelId: 'ancient_tree',
          position: [3, 0, 18],
          rotation: [0, 2.5, 0],
          scale: [1.4, 1.6, 1.4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tree_6',
          name: 'Arbre',
          type: 'static',
          modelId: 'tree',
          position: [15, 0, 16],
          rotation: [0, 0.8, 0],
          scale: [1.0, 1.1, 1.0],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_tree_7',
          name: 'Petit Arbre',
          type: 'static',
          modelId: 'tree',
          position: [20, 0, 12],
          rotation: [0, 3.2, 0],
          scale: [0.7, 0.8, 0.7],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Mushroom clusters
        {
          id: 'obj_mushroom_1',
          name: 'Champignons',
          type: 'static',
          modelId: 'mushroom',
          position: [5, 0, 14],
          rotation: [0, 0.5, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_mushroom_2',
          name: 'Champignons',
          type: 'static',
          modelId: 'mushroom',
          position: [14, 0, 8],
          rotation: [0, 1.8, 0],
          scale: [0.8, 0.9, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_mushroom_3',
          name: 'Champignons Lumineux',
          type: 'static',
          modelId: 'mushroom',
          position: [19, 0, 18],
          rotation: [0, 2.3, 0],
          scale: [1.2, 1.3, 1.2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Vines on walls/trees
        {
          id: 'obj_vines_1',
          name: 'Lierre',
          type: 'static',
          modelId: 'vines',
          position: [0.5, 1, 8],
          rotation: [0, 0, 0],
          scale: [1, 2, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_vines_2',
          name: 'Lierre',
          type: 'static',
          modelId: 'vines',
          position: [21.5, 1.5, 14],
          rotation: [0, Math.PI, 0],
          scale: [1.2, 2.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Garden fountain
        {
          id: 'obj_fountain_garden',
          name: 'Fontaine du Jardin',
          type: 'static',
          modelId: 'fountain',
          position: [11, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Benches for resting
        {
          id: 'obj_bench_1',
          name: 'Banc en Pierre',
          type: 'static',
          modelId: 'bench',
          position: [8, 0, 18],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_bench_2',
          name: 'Banc en Pierre',
          type: 'static',
          modelId: 'bench',
          position: [16, 0, 10],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Garden lanterns
        {
          id: 'obj_lantern_garden_1',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [4, 0, 12],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_lantern_garden_2',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [17, 0, 6],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_lantern_garden_3',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [12, 0, 20],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More bushes
        {
          id: 'obj_bush_3',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [19, 0, 8],
          rotation: [0, 0.7, 0],
          scale: [1.1, 1.0, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_bush_4',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [6, 0, 20],
          rotation: [0, 2.1, 0],
          scale: [0.9, 0.8, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_bush_5',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [14, 0, 3],
          rotation: [0, 1.5, 0],
          scale: [1.0, 1.0, 1.0],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More flowers
        {
          id: 'obj_flower_3',
          name: 'Fleurs Sauvages',
          type: 'static',
          modelId: 'flower',
          position: [13, 0, 17],
          rotation: [0, 0.3, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_flower_4',
          name: 'Fleurs Sauvages',
          type: 'static',
          modelId: 'flower',
          position: [2, 0, 14],
          rotation: [0, 1.2, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_flower_5',
          name: 'Fleurs Sauvages',
          type: 'static',
          modelId: 'flower',
          position: [20, 0, 2],
          rotation: [0, 2.5, 0],
          scale: [1.1, 1.1, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Garden statue
        {
          id: 'obj_statue_garden',
          name: 'Statue Ancienne',
          type: 'static',
          modelId: 'statue',
          position: [18, 0, 15],
          rotation: [0, -Math.PI / 4, 0],
          scale: [0.8, 1, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Rocks and stones
        {
          id: 'obj_rock_2',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [16, 0, 19],
          rotation: [0, 1.2, 0],
          scale: [1.0, 0.8, 1.0],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_rock_3',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [2, 0, 6],
          rotation: [0, 2.8, 0],
          scale: [0.7, 0.6, 0.7],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_rocks_2',
          name: 'Cailloux',
          type: 'static',
          modelId: 'rocks',
          position: [10, 0, 19],
          rotation: [0, 0.4, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Pot with plant
        {
          id: 'obj_pot_garden',
          name: 'Pot de Fleurs',
          type: 'static',
          modelId: 'pot',
          position: [9, 0, 16],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Well
        {
          id: 'obj_well_garden',
          name: 'Vieux Puits',
          type: 'static',
          modelId: 'well',
          position: [4, 0, 17],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Signpost
        {
          id: 'obj_signpost_garden',
          name: 'Panneau',
          type: 'static',
          modelId: 'signpost',
          position: [12, 0, 5],
          rotation: [0, Math.PI / 6, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More spectral orbs
        {
          id: 'obj_orb_3',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [16, 2.5, 14],
          rotation: [0, 0, 0],
          scale: [0.35, 0.35, 0.35],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_orb_4',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [4, 1.8, 19],
          rotation: [0, 0, 0],
          scale: [0.45, 0.45, 0.45],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
      ],
      puzzles: [
        {
          id: 'puzzle_forest_blessing',
          name: 'La Bénédiction de la Forêt',
          type: 'worldBridge',
          state: 'active',
          description: 'Obtiens la bénédiction de l\'esprit de l\'arbre ancien.',
          hint: 'Cherche dans le monde spectral...',
          linkedObjectIds: ['obj_magic_flower', 'obj_pressure_plate', 'obj_ancient_tree_spirit'],
          solution: {
            type: 'sequence',
            expected: ['obj_magic_flower', 'obj_pressure_plate', 'obj_ancient_tree_spirit'],
          },
          onSolve: [
            {
              type: 'showMessage',
              params: {
                message: 'La forêt entière semble vibrer d\'énergie positive !',
              },
            },
          ],
        },
      ],
      connections: [
        {
          targetRoomId: 'room_village_house',
          position: [6, 0, 0],
          direction: 'south',
          locked: false,
        },
        {
          targetRoomId: 'room_ancient_ruins',
          position: [12, 0, 6],
          direction: 'east',
          locked: false,
        },
      ],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'forest',
      biome: 'jungle',
      weather: 'rain',
      weatherIntensity: 0.5,
      npcs: [
        {
          id: 'npc_parrot_1',
          type: 'parrot',
          name: 'Perroquet Arc-en-ciel',
          position: [5, 2, 6],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'chirp',
          petRadius: 3,
          petCooldown: 3000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_monkey_1',
          type: 'monkey',
          name: 'Singe Espiègle',
          position: [12, 0, 10],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'jump',
          petRadius: 2.5,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_toucan_1',
          type: 'toucan',
          name: 'Toucan Coloré',
          position: [8, 2.5, 4],
          scale: 3,
          idleAnimation: 'fly',
          petAnimation: 'chirp',
          petRadius: 2.5,
          petCooldown: 3000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_lion_1',
          type: 'lion',
          name: 'Lion Majestueux',
          position: [16, 0, 16],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'nuzzle',
          petRadius: 3.5,
          petCooldown: 4000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_jaguar_1',
          type: 'jaguar',
          name: 'Jaguar Silencieux',
          position: [18, 0, 6],
          scale: 2.5,
          idleAnimation: 'sit',
          petAnimation: 'nuzzle',
          petRadius: 3,
          petCooldown: 4000,
          isPettable: true,
          visibleInWorld: 'spectral',
        },
        {
          id: 'npc_butterfly_1',
          type: 'butterfly',
          name: 'Papillon Mystique',
          position: [10, 1.5, 18],
          scale: 4,
          idleAnimation: 'fly',
          petAnimation: 'spin',
          petRadius: 2,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'both',
        },
      ],
};
